import { IConfigurationOptionGroup } from '~/domain/IConfigurationOptionGroup';

/**
 * @function
 * Checks each pack set to make sure a valid selected code exists for it
 * @param {string[]} features
 * @param {IConfigurationOptionGroup[]} packSets
 * @return The error message if there is one, otherwise don't return anything at all (undefined).
 * */
export const findInvalidPackSet = (features: string[], packSets: IConfigurationOptionGroup[]) => {
  const invalidPackSet = packSets.find((packSet) => {
    return !packSet.packs.some(packSet => features.includes(packSet.code));
  });
  return invalidPackSet;
}

export const isValidFeature = (features: string[], packSets: IConfigurationOptionGroup[]) => {
  return !findInvalidPackSet(features, packSets);
}
